import React from 'react';
var TabContent = function TabContent(_ref) {
  var selectedTab = _ref.selectedTab,
    tabId = _ref.tabId,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    hidden: selectedTab !== tabId
  }, /*#__PURE__*/React.createElement("div", {
    role: "tabpanel",
    tabIndex: 0,
    id: "tabcontent-".concat(tabId),
    "aria-labelledby": tabId
  }, children));
};
export default TabContent;